import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Work from '../views/Work.vue'
import Login from '../views/Login.vue'
import staff from '../views/staff.vue'
import home from '../views/home.vue'
import test from '../views/test.vue'
import lighttest from '../views/lighttest.vue';
import shubin from '../views/GangJin.vue';
Vue.use(VueRouter)

const routes = [
  {
    path: '/HomeView',
    name: 'HomeView',
    component: HomeView,
    children: [
      {

        path: '/staff',name: 'staff',
        component: (resolve) => require(['@/views/staff'], resolve),
      },
      {
        path: '/Work',name: 'Work',
        component: (resolve) => require(['@/views/Work'], resolve),
      },
      {      
        path: '/home',name: 'home',
        component: (resolve) => require(['@/views/home'], resolve),
      },
      {      
        path: '/lighttest/:id',name: 'lighttest',props:true,
        component: lighttest,
      },
      {      
        path: '/lighttest',name: 'lighttest',
        component: (resolve) => require(['@/views/lighttest'], resolve),
      },
      {      
        path: '/Bi',name: 'Bi',
        component: (resolve) => require(['@/views/Bi'], resolve),
      },
      {      
        path: '/LiZiQiang',name: 'LiZiQiang',
        component: (resolve) => require(['@/views/LiZiQiang.vue'], resolve),
      },
      {      
        path: '/ProcessModel',name: 'ProcessModel',
        component: (resolve) => require(['@/views/ProcessModel'], resolve),
      },
      {      
        path: '/test',name: 'test',
        component: (resolve) => require(['@/views/test'], resolve),
      },
      {      
        path: '/BiModel/BiMain',name: 'BiMain',
        component: (resolve) => require(['@/views/BiModel/BiMain.vue'], resolve),
      },
      {      
        path: '/ZiYuan/RuanJian',name: 'RuanJian',
        component: (resolve) => require(['@/views/ZiYuan/RuanJian.vue'], resolve),
      },

      // {      
      //   path: '/GangJin',name: 'GangJin',
      //   component: (resolve) => require(['@/views/GangJin'], resolve),
      //   children: [
      //     {      
      //       path: '/GangJin/GangJinGuanLi',name: 'GangJinGuanLi',
      //       component: (resolve) => require(['@/views/GangJin/GangJinGuanLi.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinPanDian',name: 'GangJinPanDian',
      //       component: (resolve) => require(['@/views/GangJin/GangJinPanDian.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinTaiZhang',name: 'GangJinTaiZhang',
      //       component: (resolve) => require(['@/views/GangJin/GangJinTaiZhang.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/QuYuHuaFen',name: 'QuYuHuaFen',
      //       component: (resolve) => require(['@/views/GangJin/QuYuHuaFen.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/XianChangWenTi',name: 'XianChangWenTi',
      //       component: (resolve) => require(['@/views/GangJin/XianChangWenTi.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/ZhiShiKu',name: 'ZhiShiKu',
      //       component: (resolve) => require(['@/views/GangJin/ZhiShiKu.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinJinDu',name: 'GangJinJinDu',
      //       component: (resolve) => require(['@/views/GangJin/GangJinJinDu.vue'], resolve),
      //     },
          

      //   ]
      // },
      
    ],
    
  },
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {      
    path: '/BimAutoCreatePlantFloor',name: 'BimAutoCreatePlantFloor',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/Main.vue'], resolve), 
  },
  {      
    path: '/GangJin',name: 'GangJin',
    component: (resolve) => require(['@/views/GangJin'], resolve),
    children: [
      {      
        path: '/GangJin/GangJinGuanLi',name: 'GangJinGuanLi',
        component: (resolve) => require(['@/views/GangJin/GangJinGuanLi.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinPanDian',name: 'GangJinPanDian',
        component: (resolve) => require(['@/views/GangJin/GangJinPanDian.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinTaiZhang',name: 'GangJinTaiZhang',
        component: (resolve) => require(['@/views/GangJin/GangJinTaiZhang.vue'], resolve),
      },
      {      
        path: '/GangJin/QuYuHuaFen',name: 'QuYuHuaFen',
        component: (resolve) => require(['@/views/GangJin/QuYuHuaFen.vue'], resolve),
      },
      {      
        path: '/GangJin/XianChangWenTi',name: 'XianChangWenTi',
        component: (resolve) => require(['@/views/GangJin/XianChangWenTi.vue'], resolve),
      },
      {      
        path: '/GangJin/ZhiShiKu',name: 'ZhiShiKu',
        component: (resolve) => require(['@/views/GangJin/ZhiShiKu.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinJinDu',name: 'GangJinJinDu',
        component: (resolve) => require(['@/views/GangJin/GangJinJinDu.vue'], resolve),
      },
      

    ]
  },
  
  {      
    path: '/BimAutoCreatePlantFloor/:id',name: 'BimAutoCreatePlantFloor',props:true,
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/Main.vue'], resolve),
  },
  {      
    path: '/LightModelCore',name: 'LightModelCore',
    component: (resolve) => require(['@/views/LightModelCore/LightMain.vue'], resolve), 
  },
]

const router = new VueRouter({
  routes
})

export default router
